import { render } from "./ProgramOutcomesDialog.vue?vue&type=template&id=667b327c"
import script from "./ProgramOutcomesDialog.vue?vue&type=script&lang=js"
export * from "./ProgramOutcomesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__